import RepositoryFactory from "@/marcom/Apicall/RepositoryFactory";
const email = RepositoryFactory.email;

export default {
  createEmailCampaign({}, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await email.createEmailCampaign(payload);

        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },
  createUserEmailTemplate({}, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await email.createUserEmailTemplate(payload);

        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },
  getAllEmailTemplate({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await email.getAllEmailTemplate(payload);
        commit("GET_ALL_EMAIL_TEMPLATE", data.data);
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },
  getEmailConfig({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await email.getEmailConfig(payload);
        commit("GET_EMAIL_CONFIG", data.data);
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },
};
